import { useEffect } from "react";
import { useLatestValue as s } from "./use-latest-value.js";
function i(t, e, o, n) {
  let u = s(o);
  useEffect(() => {
    if (!t) return;
    function r(m) {
      u.current(m);
    }
    return document.addEventListener(e, r, n), () => document.removeEventListener(e, r, n);
  }, [t, e, n]);
}
export {
  i as useDocumentEvent
};
